import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiX, FiPackage } from 'react-icons/fi';
import './OrderTypeModal.scss';

const OrderTypeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSelectPreOrder = (source) => {
    navigate('/system/ventas/nueva-preorden', { state: { source } });
    onClose();
  };

  const handleSelectCotizacion = () => {
    navigate('/system/ventas/nueva-preorden', { state: { isCotizacion: true } });
    onClose();
  };

  return (
    <div className="order-type-modal-overlay" onClick={onClose}>
      <div className="order-type-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FiX size={24} />
        </button>

        <div className="modal-body">
          {/* PRE-ORDEN Card */}
          <div className="order-type-card order-type-card--preorder">
            <div className="card-icon">
              <FiPackage size={48} />
            </div>
            <h3 className="card-title">PRE-ORDEN</h3>
            <p className="card-description">
              Para producción interna y toma de pedidos semanales
            </p>

            <div className="card-divider"></div>

            <div className="card-sources">
              <p className="sources-label">Selecciona la fuente:</p>
              <button
                className="source-btn source-btn--betel"
                onClick={() => handleSelectPreOrder('BETEL_NATURAL')}
              >
                <span className="source-icon">🌿</span>
                Betel Natural
              </button>
              <button
                className="source-btn source-btn--lab"
                onClick={() => handleSelectPreOrder('NATURALAND_LAB')}
              >
                <span className="source-icon">🧪</span>
                Naturaland Lab
              </button>
              <button
                className="source-btn source-btn--viernes"
                onClick={() => handleSelectPreOrder('BETEL_NATURAL_VIERNES')}
              >
                <span className="source-icon">📅</span>
                Betel Natural Viernes
              </button>

              <div className="sources-divider" />

              <button
                className="source-btn source-btn--cotizacion"
                onClick={handleSelectCotizacion}
              >
                <span className="source-icon">📄</span>
                Cotizaciones
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTypeModal;
